import React from "react"
import Logo from "../../../images/arden-university.png"
import guestStyles from "./guest.module.css"
import DateIcon from "../../../images/arden-icon-solid-calendar-primary.svg"
import clockIcon from "../../../images/arden-icon-solid-time-primary.svg"
import Img from "gatsby-image"

const Guest = ({ guestImage, guestParagraph, guestTitle }) => (
  <div className={`full-width ${guestStyles.recording}`}>
    <div className="page-wrapper">
      <h1 className={`black ${guestStyles.guestblack}`}>{guestTitle}</h1>
      <h3 className={guestStyles.guestgray} dangerouslySetInnerHTML={{__html: guestParagraph}}/>
      <Img className={guestStyles.guestimg} fluid={guestImage} />
    </div>
  </div>
)

export default Guest
